import { g as d } from "../../utils-BOfnFgIH.js";
import { I as r } from "../../constants-DeVuDy8J.js";
import { openBlock as n, createElementBlock as o, normalizeClass as s, createElementVNode as a } from "vue";
import { _ as u } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const c = {
  name: "DtIconFactory",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(r).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return r[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded"), this.uniqueID = d();
  }
}, f = ["aria-label", "data-qa", "aria-hidden"], m = ["clip-path"], p = ["id"];
function h(e, t, l, _, v, i) {
  return n(), o("svg", {
    "aria-label": l.ariaLabel,
    class: s([i.iconSizeClass, "d-icon d-icon--factory"]),
    "data-qa": i.dataQA,
    "aria-hidden": i.ariaHidden,
    role: "img",
    "data-name": "Factory",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12"
  }, [
    a("g", {
      "clip-path": `url(#${e.uniqueID}a)`
    }, [...t[0] || (t[0] = [
      a("path", {
        fill: "currentColor",
        "fill-rule": "evenodd",
        d: "M.94.94A1.5 1.5 0 0 1 2 .5h1A1.5 1.5 0 0 1 4.5 2v3.528l2.71-1.935A.5.5 0 0 1 8 4v1.528l2.71-1.935A.5.5 0 0 1 11.5 4v6a1.5 1.5 0 0 1-1.5 1.5H2A1.5 1.5 0 0 1 .5 10V2c0-.398.158-.78.44-1.06ZM2 1.5a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5V4.972L7.79 6.907A.5.5 0 0 1 7 6.5V4.972L4.29 6.907A.5.5 0 0 1 3.5 6.5V2a.5.5 0 0 0-.5-.5H2ZM3 9a.5.5 0 0 1 .5-.5H4a.5.5 0 0 1 0 1h-.5A.5.5 0 0 1 3 9Zm2.5 0a.5.5 0 0 1 .5-.5h.5a.5.5 0 0 1 0 1H6a.5.5 0 0 1-.5-.5ZM8 9a.5.5 0 0 1 .5-.5H9a.5.5 0 0 1 0 1h-.5A.5.5 0 0 1 8 9Z",
        "clip-rule": "evenodd"
      }, null, -1)
    ])], 8, m),
    a("defs", null, [
      a("clipPath", {
        id: `${e.uniqueID}a`
      }, [...t[1] || (t[1] = [
        a("path", {
          fill: "#fff",
          d: "M0 0h12v12H0z"
        }, null, -1)
      ])], 8, p)
    ])
  ], 10, f);
}
const b = /* @__PURE__ */ u(c, [["render", h]]);
export {
  b as default
};
//# sourceMappingURL=factory.js.map
